<button
    (click)="isShowingDropdown ? hideDropdown() : showDropdown(); $event.stopPropagation()"
    (closeDropdown)="closeDropdown()"
    (keyup)="handleKeyupEvent($event)"
    type="button"
    aria-expanded="false"
    class="flex">
    <h5>{{buttonText}}</h5>
    <global-home-icon class="icon" [svg]="dropdownSvg" [size]="16"></global-home-icon>
</button>
<ul
    *ngIf="isShowingDropdown"
    (keyup)="handleKeyupEvent($event)"
    class="dropdown border border-radius-s">
    <ng-container *ngIf="selectList;">
        <li *ngFor="let item of selectList" >
            <a class="block text-darker text-size-s" target="_blank" href="{{item.url}}">{{item.name}}</a>
        </li>
    </ng-container>
</ul>

